import axios from "axios";
import getSignature from "../Common/getSignature";
import { toast } from "react-toastify";


//LIVE APIs
// export const API_BASE_PATH_ADMIN = "https://apis.bitv3.cloud/admin"; // BASE_URL_LIVE NEW
// export const API_BASE_PATH_USER = "https://apis.bitv3.cloud/user";
// export const API_BASE_PATH_USER_LOGIN = "https://bitv3.cloud";
// export const SOCKET_SERVER_URL_WSS = "wss://https://apis.bitv3.cloud/";

// Test APIS
export const API_BASE_PATH_ADMIN = "https://testapis.bitv3.cloud/admin"; // BASE_URL_LIVE NEW
export const API_BASE_PATH_USER = "https://testapis.bitv3.cloud/user";
export const API_BASE_PATH_USER_LOGIN = "https://testuser.bitv3.cloud";
export const SOCKET_SERVER_URL_WSS = "wss://testapis.bitv3.cloud";

//Testing Local APIs
// export const API_BASE_PATH_ADMIN = "http://72.61.172.155:6277/admin"; // BASE_URL_LIVE NEW
// export const API_BASE_PATH_USER = "http://72.61.172.155:6277/user";
// export const API_BASE_PATH_USER_LOGIN = "http://localhost:3000";
// export const SOCKET_SERVER_URL_WSS = "wss://http://72.61.172.155:6277/";

// export const API_BASE_PATH_ADMIN = "https://apis.bitv3.ai/admin"; // BASE_URL_LIVE OLD
// export const API_BASE_PATH_USER = "https://apis.bitv3.ai/user";
// export const API_BASE_PATH_USER_LOGIN = "https://bitv3.ai";
// export const SOCKET_SERVER_URL_WSS = "wss://apis.bitv3.ai";

//Local APIs
// export const API_BASE_PATH_ADMIN = 'http://72.61.224.88:5599/admin';
// export const API_BASE_PATH_USER_LOGIN = 'http://192.168.1.79:3001/login';

// AI WORLD testing APIs
// export const API_BASE_PATH_ADMIN = "https://testapis.aiworld.care/admin"; // BASE_URL_TEST
// export const API_BASE_PATH_USER = "https://testapis.aiworld.care/user";
// export const API_BASE_PATH_USER_LOGIN = "https://testuser.aiworld.care/login";
// export const SOCKET_SERVER_URL_WSS = "wss://testapis.aiworld.care";

// ROYAL INFINITY TEST APIs
// export const API_BASE_PATH_ADMIN = "http://147.93.27.161:9991/admin"; // BASE_URL_LIVE
// export const API_BASE_PATH_USER = "http://147.93.27.161:9991/user";
// export const API_BASE_PATH_USER_LOGIN = "http://147.93.27.161:9991";
// export const SOCKET_SERVER_URL_WSS = "wss://147.93.27.161:9991";

const apiCall = async (method, endpoint, data = null, showToast = false) => {
  const Authorization = localStorage.getItem("authToken");

  let headers = {
    Authorization,
  };

  // Only set 'Content-Type' to 'application/json' if not sending FormData
  if (!(data instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  try {
    const response = await axios({
      method: method,
      url: `${API_BASE_PATH_ADMIN}${endpoint}`,
      data: data,
      headers: headers,
    });
    console.log(endpoint, response.data);
    showToast && toast.success(response.data.message || "Request success");
    return { data: response.data, error: null };
  } catch (error) {
    console.log(endpoint, error);
    let code = 0;
    let errorMessage = "An unexpected error occurred";

    if (error.response) {
      errorMessage = error.response.data.message || error.response.statusText;
      code = error.response.data.code || 0;
    } else if (error.request) {
      errorMessage = "No response from server. Please try again later.";
    } else {
      errorMessage = error.message;
    }

    showToast && toast.error(errorMessage || "Request failed"); // Show error message using toast
    return { data: null, error: { code, message: errorMessage } };
  }
};

export default apiCall;
